import * as React from 'react';
import { Button, Modal, ProgressIndicator } from '@salesforce/design-system-react';
import { MatchingRule } from 'lib/types';
import bodySvg1 from './modal-2-body.svg';
import bodySvg2 from './modal-2-body-brunello.svg';

interface EditModal2Props {
	onClose: () => void;
	onSave: () => void;
	rule: MatchingRule;
	brand: 'default' | 'brunello';
}

const steps = [{id: 1, label: 'Edit Matching Rule'}, {id: 2, label: 'Preview Matching Rule'}];

const EditModal2: React.SFC<EditModal2Props> = ({ brand, onClose, onSave, rule }) => (
	<Modal
		containerClassName={['matching-rules_modal2']}
		footer={[
			<Button className="slds-float_left" key="a" label="Cancel" />,
			<ProgressIndicator
				className="slds-float_left slds-progress_shade"
				key="b"
				completedSteps={[steps[0]]}
				steps={steps}
				selectedStep={steps[1]}
			/>,
			<Button key="b" label="Save & Activate" onClick={onSave} variant="brand" />
		]}
		isOpen={true}
		onRequestClose={onClose}
		size="large"
		title="Edit Matching Rule"
	>
		<div className="matching-rules_modal2-body">
			<object data={brand === 'default' ? bodySvg1 : bodySvg2} width="1123" height="531" />
		</div>
	</Modal>
);

export default EditModal2;



// WEBPACK FOOTER //
// ./src/MatchingRules/edit-modal-2.tsx